module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAABGUlEQVQ4T53UPSjFYRTH8c+lJAOTpIhRmcxsbCKlkN0uLwODugYWYjDZkIXNJi+LMihlVRaLySYvg7dO3Vu3v///f2/O8tQ55/uc8zy/5zwFf60Jq5hCK+6xib1kaiEFPsNQin8OW5X+JDyI8xQwXC9ow3s5noRXUMyAw92P6yx4DUs5cHR2mQXPYDcH7sZjFtxRCtalbHCHvrwLi9ghplPgSRxVg9txi1jLdoyJWnSOnA3MVySH7hfV4JBuGDvoSlRexkNW22NYR0/Gbf+UHlBIGccSlZpxgNEciSpD39jGQsAnGKkRrExbDPgT9f+ATwO+wsA/4GL5zLMYR2+VLt5wU5rt/eRUNaITLYhPoQEfeMUznvBV7vIXYkEtwt4BgVMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/user.png
// module id = oLaq
// module chunks = 1